<template>
  <div>
    <az-back-button :route="{name: 'credenciamento', params: {id: credenciamentoId}, query: {edicao: true}}" text="Voltar para o credenciamento"></az-back-button>
    <br>
    <filtros-documentos-credenciamento :fornecedoresDisponiveis="fornecedoresDisponiveisFiltro"
                        :tiposDisponiveis="tiposDisponiveis"
                        @pesquisar="buscarDocumentosVirtualizadosComFiltro"
                        ref="filtrosDocumentos"/>
    <v-divider/>
    <v-layout d-flex wrap align-center class="ml-2 pt-1 pb-1 justify-start acoes-em-massa">
      <v-flex xs12 sm12 md6 d-flex>
        <v-btn @click="abrirModalConfirmarAssinar(true)" style="text-align: center">
          <icone-assinar-documento class="mr-1"/>
          Assinar Selecionados
        </v-btn>
        <v-btn @click="abrirModalConfirmarJuntar(true)" style="text-align: center">
          <icone-juntar-documento class="mr-1"/>
          Juntar Selecionados
        </v-btn>
        <v-btn @click="abrirModalBaixarDocumentosSelecionados" style="text-align: center">
          <v-icon class="mr-1">cloud_download</v-icon>
          Baixar Selecionados
        </v-btn>
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout v-if="exibirMensagemErroJuntar" class="mx-4 my-2 mensagem-erro-juntar error">
      <v-flex>
      <span class="mx-2" style="font-weight: bold">
        Ocorreu um erro ao juntar. Os seguintes documentos não puderam ser juntados ao processo digital:
      </span>
      <div class="mt-2">
        <v-chip v-for="doc in documentosNaoJuntados" :key="doc.documentoVirtualizadoId" class="chip-documento-erro" small @click="destacarDocTabela(doc)" text-color="black">
          {{doc.nome}}
          <v-tooltip content-class="tooltip-erro-documento" :disabled="!doc.erro" top>
            <v-icon class="ml-1" slot="activator" style="color: darkorange">warning</v-icon>
            Motivo: {{doc.erro}}
          </v-tooltip>
        </v-chip>
      </div>
      </v-flex>
      <v-icon @click="exibirMensagemErroJuntar = false" class="icone-fechar-mensagem-erro">close</v-icon>
    </v-layout>
    <v-divider/>
    <painel-documentos-tabela :documentos="documentosVirtualizadosCredenciamento" 
                              :totalItens="totalItens"
                              :paginacaoInterna="paginacaoInterna"
                              ref="tabelaDocumentos"
                              @baixar="abrirModalBaixarDocumento"
                              @assinar="abrirModalConfirmarAssinar(false, ...arguments)"
                              @juntar="abrirModalConfirmarJuntar(false, ...arguments)"
                              @desentranhar="desentranharDocumento"
                              @reordenar="abrirModalreordenarDocumento"
                              @cancelar="abrirModalConfirmarCancelamento"
                              @enviar-pncp="enviarDocumentoPncp"
                              @remover-pncp="removerDocumentoPncp"
    />
    <paginacao-tabela
        v-if="documentosVirtualizadosCredenciamento && documentosVirtualizadosCredenciamento.length > 0"
        show-items-per-page
        :page="paginacaoInterna.page"
        :itemsPerPage="paginacaoInterna.rowsPerPage"
        :totalPaginas="totalPaginas"
        :totalItens="totalItens"
        @update-page="tratarEventoAtualizarPagina"
        @update-items-per-page="tratarEventoAtualizarItensPorPagina"
        style="margin-bottom: 20px;"
    >
      <template #pagination-actions>
        <slot name="pagination-actions"></slot>
      </template>
    </paginacao-tabela>
    <div style="height: 60px; width: 100%;"></div>
    <modal-confirmar-cancelar-documento :mostrarDialogoCancelarDocumento="exibirModalConfirmarCancelamento"
                                        @fechar="exibirModalConfirmarCancelamento = false"
                                        @confirmar="cancelarDocumento(documentoManejando, ...arguments)"
    />
    <modal-confirmar-juntar-documento :mostrarDialogoJuntarDocumento="exibirModalConfirmarJuntar"
                                      :multiplo="manejandoMultiplos"
                                      @fechar="exibirModalConfirmarJuntar = false"
                                      @confirmar="selecionarMetodoJuntar(documentoManejando, manejandoMultiplos)"
    />
    <modal-confirmar-assinar-documento :mostrarDialogoAssinarDocumento="exibirModalConfirmarAssinar"
                                      :multiplo="manejandoMultiplos"
                                      @fechar="exibirModalConfirmarAssinar = false"
                                      @confirmar="selecionarMetodoAssinar(documentoManejando, manejandoMultiplos)"
    />
    <modal-confirmar-baixar-documento :mostrarDialogoBaixarDocumento="exibirModalConfirmarBaixar"
                                       @fechar="exibirModalConfirmarBaixar = false"
                                       @confirmar="baixarDocumento(documentoManejando, ...arguments)"
    />

    <ModalConfirmarReordenarDocumento v-if="exibirModalReordenar"
                               :documentoReordenar="documentoManejando"
                               :documentosJuntados="documentosJuntados"
                               @fechar="exibirModalReordenar = false"
                               @confirmar="reordenarDocumento(documentoManejando, ...arguments)"
    />

    <modal-selecao-tipo-assinatura
        :exibir="exibirModalSelecaoTipoAssinatura"
        :idLicitacao="credenciamentoId"
        :titulo="'Selecionar Tipo de Assinatura'"
        :documentos="documentosParaAssinar"
        @fechar-modal="exibirModalSelecaoTipoAssinatura = false"
        @buscar-assinaturas-nao-concluidas="buscarDocumentosVirtualizados"
        @resetar-documentos="resetarDocumentosAssinatura"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes, mutationTypes} from '@/commons/constants'
import PainelDocumentosTabela from "@/views/credenciamento/detalhe-credenciamento/orgao/documentosvirtualizacao/PainelDocumentosTabela.vue";
import IconeAssinarDocumento from "@/commons/components/icones/IconeAssinarDocumento.vue";
import IconeJuntarDocumento from "@/commons/components/icones/IconeJuntarDocumento.vue";
import ModalConfirmarCancelarDocumento from "@/commons/components/ModalConfirmarCancelarDocumento.vue";
import ModalConfirmarJuntarDocumento from "@/commons/components/ModalConfirmarJuntarDocumento.vue";
import ModalConfirmarAssinarDocumento from "@/commons/components/ModalConfirmarAssinarDocumento.vue";
import ModalConfirmarBaixarDocumento from "@/commons/components/ModalConfirmarBaixarDocumento.vue";
import store from "@/commons/store";
import ModalSelecaoTipoAssinatura
  from "@/views/credenciamento/detalhe-credenciamento/assinaturas/selecao-tipo-assinatura/ModalSelecaoTipoAssinatura.vue";
import FiltrosDocumentosCredenciamento
  from "@/views/credenciamento/detalhe-credenciamento/orgao/documentosvirtualizacao/FiltrosDocumentosCredenciamento.vue";
import PaginacaoTabela from "@/commons/components/PaginacaoTabela.vue";
import ModalConfirmarReordenarDocumento from "@/commons/components/ModalConfirmarReordenarDocumento.vue";

export default {
  name: 'CredenciamentoDocumentosVirtualizacao',
  components: {
    ModalConfirmarReordenarDocumento,
    FiltrosDocumentosCredenciamento,
    ModalSelecaoTipoAssinatura,
    ModalConfirmarBaixarDocumento,
    ModalConfirmarAssinarDocumento,
    ModalConfirmarJuntarDocumento,
    ModalConfirmarCancelarDocumento,
    IconeJuntarDocumento,
    IconeAssinarDocumento,
    PainelDocumentosTabela,
    PaginacaoTabela
  },
  data() {
    return {
      credenciamentoId: null,
      totalItens: 0,
      totalPaginas: 0,
      paginacaoInterna: {
        groupBy: [],
        groupDesc: [],
        rowsPerPage: 10,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: 'id',
        sortByDefault: ['id'],
        descending: false,
        sortDescDefault: [true]
      },
      fornecedoresDisponiveisFiltro: [],
      tiposDisponiveis: null,
      documentosNaoJuntados: null,
      exibirMensagemErroJuntar: false,
      documentoManejando: null,
      manejandoMultiplos: null,
      exibirModalConfirmarCancelamento: false,
      exibirModalConfirmarJuntar: false,
      exibirModalConfirmarAssinar: false,
      exibirModalConfirmarBaixar: false,
      exibirModalSelecaoTipoAssinatura: false,
      exibirModalReordenar: false,
      documentosJuntados: [],
    }
  },
  computed: {
    store() {
      return store
    },
    ...mapState(['licitacao', 'documentosVirtualizadosCredenciamento']),
    documentosParaAssinar() {
      let documentos = []

      if (this.manejandoMultiplos) {
        documentos = (this.documentosVirtualizadosCredenciamento || []).filter(documento => {
          return this.$refs.tabelaDocumentos && this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
        }).filter(doc => !doc.juntado && !doc.cancelado)
      } else if (this.documentoManejando) {
        documentos = [this.documentoManejando]
      }

      return documentos.map(doc => ({
        ...doc,
        idVirtualizado: doc.documentoVirtualizadoId,
        titulo: doc.nome
      }))
    }
  },
  watch: {
    paginacaoInterna: {
      async handler() {
        await this.buscarDocumentosVirtualizados()
      },
      deep: true,
    }
  },
  async mounted() {
    try {
      this.setCredenciamentoId()
      this.carregarFiltrosRouter()
      await this.buscarDocumentosVirtualizados()
    } catch (e) {
      this.mostrarNotificacaoErro(e.message)
    }
  },
  methods: {
    destacarDocTabela(doc){
      const elementoDocumento = document.getElementById(doc.documentoVirtualizadoId)
      elementoDocumento.scrollIntoView({block: 'start', behavior:'smooth'});
      if(!elementoDocumento.classList.contains('transicionar-destacado')) {
        elementoDocumento.classList.add('transicionar-destacado');
        setTimeout(() => {
          elementoDocumento.classList.remove('transicionar-destacado');
        }, 1000)
      }
    },
    async buscarDocumentosVirtualizados(resetarPaginacao = false){
      this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_DOCUMENTOS_VIRTUALIZADOS_CREDENCIAMENTO, [])
      const filtros = this.$refs.filtrosDocumentos.filtros

      if (resetarPaginacao) {
        this.paginacaoInterna.page = 1
      }

      this.setMensagemLoading("Buscando documentos...")
      const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.BUSCAR_DOCUMENTOS_CREDENCIAMENTO,
          {
            credenciamentoId: this.credenciamentoId,
            paginacao: this.paginacaoInterna,
            filtros: filtros
          }
      )

      if (response && response.documentos && response.documentos.length > 0) {
        this.totalItens = response.totalElements;
        this.totalPaginas = response.totalPages;
      }

      this.$store.commit(mutationTypes.CREDENCIAMENTO.SET_DOCUMENTOS_VIRTUALIZADOS_CREDENCIAMENTO, response.documentos)
      this.fornecedoresDisponiveisFiltro = response.fornecedoresDisponiveis
      this.tiposDisponiveis = response.tiposDisponiveis
    },
    async buscarDocumentosVirtualizadosComFiltro(){
      await this.buscarDocumentosVirtualizados(true)
    },
    async selecionarMetodoJuntar(doc, multiplos){
      this.exibirModalConfirmarJuntar = false
      if(multiplos){
        await this.juntarEmLote();
      }else{
        await this.juntarDocumento(doc)
      }
      this.manejandoMultiplos = false
      this.documentoManejando = null
      await this.buscarDocumentosVirtualizados()
    },
    async selecionarMetodoAssinar(doc, multiplos){
      this.exibirModalConfirmarAssinar = false
      if(multiplos){
        await this.assinarEmLote();
      }else{
        await this.assinarDocumento(doc)
      }
      this.manejandoMultiplos = false
      this.documentoManejando = null
    },
    async juntarDocumento(doc){
      const payload = {
        documentoId: doc.documentoId,
        documentoVirtualizadoId: doc.documentoVirtualizadoId,
        tipoDocumento: doc.tipo,
        licitacaoId: this.credenciamentoId
      }
      const resp = await this.$store.dispatch(actionTypes.FLOWBEE.JUNTAR_DOCUMENTO, payload)
      if(resp.juntadoComSucesso === true){
        this.mostrarNotificacaoSucesso('Documento juntado com sucesso!')
        doc.situacaoDocumento = 'JUNTADO'
        doc.juntado = true
      }else{
        throw new Error('Ocorreu um erro ao juntar o documento.')
      }
    },
    assinarDocumento(url){
      window.open(url, '_blank').focus();
    },
    async assinarEmLote() {
      const documentos = (this.documentosVirtualizadosCredenciamento || []).filter(documento => {
        return this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
      }).filter(doc => !doc.juntado && !doc.cancelado && doc.situacaoDocumento === 'NAO_JUNTADO' && !doc.ehTermoDesentranhamento)

      const resultado = await this.$store.dispatch(actionTypes.FLOWBEE.ASSINAR_EM_LOTE,
          {
            licitacaoId: this.credenciamentoId,
            documentosIds: documentos.map(documento => documento.documentoVirtualizadoId)
          })
      if (resultado.sucesso) {
        this.mostrarNotificacaoSucesso("Documentos assinados com sucesso!")
      } else {
        this.mostrarNotificacaoErro("Não foi possível assinar!")
      }
    },
    async enviarDocumentoPncp(doc) {
      this.habilitarLoadingGlobal()
      this.setMensagemLoading("Enviando documento ao PNCP...")
      try {
        await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DOCUMENTO.ENVIAR_PNCP, {
          credenciamentoId: this.credenciamentoId,
          tipoDocumento: doc.tipo,
          entidadeId: doc.documentoId,
        })
        this.mostrarNotificacaoSucesso('Documento enviado ao PNCP com sucesso!')
        await this.buscarDocumentosVirtualizados()
      } catch (e) {
        const backendMsg = e && e.response && e.response.data && (e.response.data.message || e.response.data.mensagem || e.response.data.error || e.response.data.erro)
        const fallbackMsg = e && (e.message || e.toString())
        this.mostrarNotificacaoErro(backendMsg || fallbackMsg || 'Ocorreu um erro ao enviar o documento ao PNCP.')
      } finally {
        this.desabilitarLoadingGlobal()
      }
    },
    async removerDocumentoPncp(doc) {
      this.habilitarLoadingGlobal()
      this.setMensagemLoading("Removendo documento do PNCP...")
      try {
        await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DOCUMENTO.REMOVER_PNCP, {
          credenciamentoId: this.credenciamentoId,
          tipoDocumento: doc.tipo,
          entidadeId: doc.documentoId,
        })
        this.mostrarNotificacaoSucesso('Documento removido do PNCP com sucesso!')
        await this.buscarDocumentosVirtualizados()
      } catch (e) {
        const backendMsg = e && e.response && e.response.data && (e.response.data.message || e.response.data.mensagem || e.response.data.error || e.response.data.erro)
        const fallbackMsg = e && (e.message || e.toString())
        this.mostrarNotificacaoErro(backendMsg || fallbackMsg || 'Ocorreu um erro ao remover o documento do PNCP.')
      } finally {
        this.desabilitarLoadingGlobal()
      }
    },
    async juntarEmLote(){
      const documentosSelecionados = (this.documentosVirtualizadosCredenciamento || []).filter(documento => {
        return this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
      }).filter(doc => !doc.juntado && !doc.cancelado && doc.situacaoDocumento === 'NAO_JUNTADO' && !doc.ehTermoDesentranhamento)

      if(this.$refs.tabelaDocumentos.selecionados < 1){
        this.mostrarNotificacaoErro("É necessário selecionar pelo menos um documento não juntado!")
        return;
      }

      if(documentosSelecionados.length < 1){
        this.mostrarNotificacaoErro("Todos os documentos selecionados já foram juntados ou cancelados!")
        return;
      }
      if(documentosSelecionados.length === 1){
        await this.juntarDocumento(documentosSelecionados[0])
        return;
      }
      const requestObj = {
        licitacaoId: this.credenciamentoId,
        documentos: documentosSelecionados.map(doc => {
          return {
            documentoId: doc.documentoId,
            documentoVirtualizadoId: doc.documentoVirtualizadoId,
            tipoDocumento: doc.tipo
          }
        })
      }
      const resultado = await this.$store.dispatch(actionTypes.FLOWBEE.JUNTAR_EM_LOTE, requestObj)

      this.documentosNaoJuntados = resultado.documentosNaoJuntados.map(naoJuntadoApi => {
            const documentoNaoJuntado = (this.documentosVirtualizadosCredenciamento || []).find(
                doc => doc.documentoVirtualizadoId === naoJuntadoApi.documentoVirtualizadoId
            )
            documentoNaoJuntado.erro = naoJuntadoApi.erro
            return documentoNaoJuntado
          }
      )
      const idsNaoJuntados = resultado.documentosNaoJuntados.map(doc => doc.documentoVirtualizadoId)
      ;(this.documentosVirtualizadosCredenciamento || []).forEach(doc => {
          const documentoVirtualizadoId = doc.documentoVirtualizadoId
          if(this.$refs.tabelaDocumentos.selecionados.includes(documentoVirtualizadoId) && !idsNaoJuntados.includes(documentoVirtualizadoId)){
            doc.situacaoDocumento = 'JUNTADO'
            doc.juntado = true
          }
      })
      if(resultado.documentosNaoJuntados.length > 0) {
        this.exibirMensagemErroJuntar = true
      }else{
        this.mostrarNotificacaoSucesso("Documentos juntados com sucesso!")
        this.exibirMensagemErroJuntar = false
      }
    },
    async baixarDocumento(doc, tipoDownload) {
      if (doc.documentosSelecionados) {
        await this.baixarDocumentosSelecionados(doc.documentosSelecionados, tipoDownload)
        this.exibirModalConfirmarBaixar = false
        return
      }

      const payload = {
        licitacaoId: this.credenciamentoId,
        documentoVirtualizadoId: doc.documentoVirtualizadoId,
        nomeArquivo: doc.nome,
        opcaoDownloadVirtualizacao: tipoDownload
      }
      await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_DOCUMENTO, payload)
      this.exibirModalConfirmarBaixar = false
    },
    async baixarDocumentosSelecionados(documentosSelecionados, tipoDownload) {
      try {
        this.habilitarLoadingGlobal()

        const payload = {
          licitacaoId: this.credenciamentoId,
          documentos: documentosSelecionados.map(doc => ({
            documentoVirtualizadoId: doc.documentoVirtualizadoId,
            nomeArquivo: doc.nome
          })),
          opcaoDownloadVirtualizacao: tipoDownload
        }
        await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_DOCUMENTOS_SELECIONADOS, payload)
        this.mostrarNotificacaoSucesso("Download iniciado com sucesso!")

      } catch (error) {
        this.mostrarNotificacaoErro("Erro ao baixar documentos selecionados: " + error.message)
      } finally {
        this.desabilitarLoadingGlobal()
      }
    },
    async reordenarDocumento(doc, posicao) {
      this.exibirModalReordenar = false
      const payload = {
        licitacaoId: this.credenciamentoId,
        documentoVirtualizadoId: doc.documentoVirtualizadoId,
        novoNumeroSequencial: posicao
      }
      await this.$store.dispatch(actionTypes.FLOWBEE.REORDENAR_DOCUMENTO, payload)
      await this.buscarDocumentosVirtualizados()
      this.mostrarNotificacaoSucesso("Documento reordenado com sucesso!")
    },
    desentranharDocumento(doc){
      this.$router.push({name: 'credenciamentoDesentranhamento', params:
          {
            id: this.credenciamentoId,
            documentoVirtualizadoId: doc.documentoVirtualizadoId
          }
      })
    },
    async abrirModalreordenarDocumento(doc){
      const data = await this.$store.dispatch(actionTypes.FLOWBEE.BUSCAR_TODOS_DOC_JUNTADO_PROCESSO, this.credenciamentoId)
      this.documentosJuntados = data.documentosVirtualizados

      if(this.documentosJuntados.length === 1){
        this.mostrarNotificacaoErro("Não é possível reordenar. Só existe um documento juntado.")
        return
      }
      this.documentoManejando = doc
      this.exibirModalReordenar = true
    },
    abrirModalConfirmarCancelamento(doc){
      this.documentoManejando = doc
      this.exibirModalConfirmarCancelamento = true
    },
    abrirModalBaixarDocumento(doc){
      this.documentoManejando = doc
      this.exibirModalConfirmarBaixar = true
    },
    abrirModalConfirmarAssinar(multiplo, doc){
      const nomeUsuarioLogado = this.$store.state.loki.user.fullName.toUpperCase()
      if(multiplo) {
        if(this.$refs.tabelaDocumentos.selecionados.length === 0){
          this.mostrarNotificacaoErro("É necessário selecionar pelo menos um documento para assinar.")
          return
        }
        const documentos = (this.documentosVirtualizadosCredenciamento || []).filter(documento => {
          return this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
        })
        if(documentos.every(doc => doc.juntado || doc.cancelado)){
          this.mostrarNotificacaoErro("Não é possível assinar. Todos os documentos selecionados estão juntados ou cancelados.")
          return
        }
        const documentosAssinados = documentos.filter(doc =>
                doc.assinaturas && doc.assinaturas.some(assinatura =>
                    (assinatura.nomeSignatario || '').toUpperCase() === nomeUsuarioLogado
                )
        );
        if (documentosAssinados.length > 0) {
          const nomes = documentosAssinados.map(doc => doc.nome).join(', ');
          this.mostrarNotificacaoErro(
              `Não é possível assinar. Você já assinou os seguintes documentos: ${nomes}.`
          );
          return;
        }
      }

      if (!multiplo && doc.assinaturas && doc.assinaturas.some(assinatura => (assinatura.nomeSignatario || '').toUpperCase() === nomeUsuarioLogado)){
        this.mostrarNotificacaoErro("Não é possível assinar. Você já assinou este documento.")
        return
      }

      this.documentoManejando = doc
      this.manejandoMultiplos = multiplo

      if (multiplo) {
        this.exibirModalConfirmarAssinar = true
      } else {
        this.exibirModalSelecaoTipoAssinatura = true;
      }
    },
    abrirModalConfirmarJuntar(multiplo, doc){
      this.documentoManejando = doc
      this.manejandoMultiplos = multiplo
      this.exibirModalConfirmarJuntar = true
    },
    abrirModalBaixarDocumentosSelecionados() {
      if(this.$refs.tabelaDocumentos.selecionados.length === 0) {
        this.mostrarNotificacaoErro("É necessário selecionar pelo menos um documento para baixar.")
        return
      }

      const documentosSelecionados = (this.documentosVirtualizadosCredenciamento || []).filter(documento => {
        return this.$refs.tabelaDocumentos.selecionados.includes(documento.documentoVirtualizadoId)
      }).filter(doc => doc.situacao !== 'CANCELADO')

      if(documentosSelecionados.length === 0) {
        this.mostrarNotificacaoErro("Nenhum documento válido selecionado para download.")
        return
      }

      if(documentosSelecionados.length === 1) {
        const doc = documentosSelecionados[0]
        this.abrirModalBaixarDocumento(doc)
        return
      }

      this.documentoManejando = {
        documentosSelecionados: documentosSelecionados,
        nome: `${documentosSelecionados.length} documento(s) selecionado(s)`
      }
      this.manejandoMultiplosBaixar = true
      this.exibirModalConfirmarBaixar = true
    },
    async cancelarDocumento(doc, motivo){
      this.exibirModalConfirmarCancelamento = false
      const payload = {
        licitacaoId: this.credenciamentoId,
        documentoVirtualizadoId: doc.documentoVirtualizadoId,
        tipoDocumento: doc.tipo,
        motivoCancelamento: motivo
      }
      const resultado = await this.$store.dispatch(actionTypes.FLOWBEE.CANCELAR_DOCUMENTO, payload)
      if(resultado.canceladoComSucesso) {
        this.mostrarNotificacaoSucesso("Documento cancelado com sucesso!")
        doc.situacaoDocumento = 'CANCELADO'
        doc.cancelado = true
      }
    },
    setCredenciamentoId() {
      this.credenciamentoId = this.$route.params.id
    },
    carregarFiltrosRouter(){
      if(this.$route.params.filtros){
        if(this.$route.params.filtros.situacao) {
          this.$refs.filtrosDocumentos.filtros.situacao = this.$route.params.filtros.situacao
        }
      }
    },
    tratarEventoAtualizarPagina(page) {
      this.paginacaoInterna.page = page
    },
    tratarEventoAtualizarItensPorPagina(rowsPerPage) {
      this.paginacaoInterna.page = 1
      this.paginacaoInterna.rowsPerPage = rowsPerPage
    },
    resetarDocumentosAssinatura() {
      this.documentoManejando = null
      this.manejandoMultiplos = false
      this.buscarDocumentosVirtualizados()
    }
  }
}
</script>
<style>
.icone-fechar-mensagem-erro {
  color: white !important;
  height: 24px;
}

.mensagem-erro-juntar {
  margin-top: 5px;
  border: 4px solid red;
  border-radius: 10px;
  color: white;
}

.chip-documento-erro {
  background-color: white !important;
}

.chip-documento-erro:after {
  color: white;
}

html {
  scroll-behavior: smooth;
}

.tooltip-erro-documento {
  opacity: 1 !important;
}
</style>
